import { render } from "./ChatForm.vue?vue&type=template&id=ff1ed56c&scoped=true"
import script from "./ChatForm.vue?vue&type=script&lang=ts"
export * from "./ChatForm.vue?vue&type=script&lang=ts"

import "./ChatForm.vue?vue&type=style&index=0&id=ff1ed56c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-ff1ed56c"

export default script